module.exports = __webpack_public_path__ + "static/media/redness.49c3ce25.svg";